import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  SimpleGrid,
  Stack,
  Text
} from "@chakra-ui/react";
import { SingleDatepicker } from "chakra-dayzed-datepicker";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ContatoType } from "models/contato_type";
import { OrderType } from "models/order_type";
import { OptionType } from "models/select_mode";
interface IOrderHeader {
  accountSelected: OrderType;
  textColor: string;
  contatoAgencia: ContatoType;
  contatoCliente: ContatoType;
  approve: (type: string) => void;
  reprove : (type: string) => void;
  cabecalhoAprovado: boolean;

}

const OrderHeader = ({
  accountSelected,
  textColor,
  contatoAgencia,
  contatoCliente,
  approve,
  reprove,
  cabecalhoAprovado,
}: IOrderHeader) => {
  return (
    <Box>
      <Box mb={"32px"} flexDirection={"row"}>
        <Stack direction={["column", "row"]} spacing="24px">
          <Text
            textAlign="left"
            color={"#422AFB"}
            fontWeight={"bold"}
            fontSize={24}
            w={"auto"}
            mt={4}
          >
            Revisão de Dados de cabeçalho :
          </Text>
          {cabecalhoAprovado ? (
            <Text color={"green"} fontWeight={"bold"} mt={6}>
              Dados de cabeçalho aprovados
            </Text>
          ) : (
            <Text color={"red"} fontWeight={"bold"} mt={6}>
              Dados de cabeçalho em revisão
            </Text>
          )}
        </Stack>
        <Button colorScheme="red" variant="solid" float={"right"} mt={-12}         
          onClick={() => {
            reprove("1");
          }} >
          REVISAR
        </Button>
        <Button
          colorScheme="green"
          variant="solid"
          float={"right"}
          mt={-12}
          mr={108}
          onClick={() => {
            approve("1");
          }}
        >
          APROVAR
        </Button>
      </Box>
      <SimpleGrid columns={5} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            <Text> Nome do Projeto</Text>
          </FormLabel>
          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Preencha o Nome do Projeto"
            fontWeight="bold"
            defaultValue={accountSelected?.nome}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Data
          </FormLabel>

          <SingleDatepicker
            name="date-input"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""),
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ),
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date(accountSelected?.data)}
            onDateChange={function (date: Date): void {
              throw new Error("Function not implemented.");
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Status
          </FormLabel>

          <Select size="md" defaultValue={accountSelected?.status} disabled>
            <option value="1">ABERTO</option>
            <option value="2">EM NEGOCIAÇÃO</option>
            <option value="3">APROVADO</option>
            <option value="4">EM PRODUÇÃO</option>
            <option value="5">CONCLUÍDO</option>
            <option value="6">DECLINADO</option>
            <option value="7">VENCIDO</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Responsável Orçamento
          </FormLabel>
          <Input
            isRequired={false}
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder="Usuário"
            fontWeight="bold"
            size="md"
            disabled={true}
            defaultValue={accountSelected?.Usuario?.nome}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Empresa Saída/Filial
          </FormLabel>

          <Select
            size="md"
            onChange={(e) => {}}
            defaultValue={accountSelected?.empresaSaiadaId}
          >
            <option value={accountSelected?.empresaSaida?.id}>
              {accountSelected?.empresaSaida?.nome}
            </option>
          </Select>
        </FormControl>
      </SimpleGrid>


        {accountSelected?.showAgencia && (
          <SimpleGrid columns={4} spacing={2} mt={4}>
            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Agência
              </FormLabel>

              <AutoComplete<OptionType, false, GroupBase<OptionType>>
                size="md"
                onChange={(e) => {}}
                placeholder="Busque a Agência"
                name={"agencia"}
                value={{
                  label: accountSelected?.agencia?.nome,
                  value: accountSelected?.agencia?.id,
                }}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Nome do Contato da Agência
              </FormLabel>
              <Select value={contatoAgencia?.id} size="md" onChange={(e) => {}}>
                <option value={contatoAgencia?.id}>
                  {contatoAgencia?.nome}
                </option>
              </Select>
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Email do Contato da Agência
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder="Email do Contato da Agência"
                fontWeight="bold"
                size="md"
                disabled={false}
                value={accountSelected?.contatoAgenciaEmail}
              />
            </FormControl>

            <FormControl>
              <FormLabel
                display="flex"
                ms="4px"
                fontSize="sm"
                fontWeight="bold"
                color={textColor}
                mb="8px"
              >
                Telefone do Contato da Agência
              </FormLabel>

              <Input
                fontSize="sm"
                ms={{ base: "0px", md: "0px" }}
                type="text"
                placeholder=" Telefone do Contato da Agência"
                fontWeight="bold"
                size="md"
                disabled={false}
                value={accountSelected?.contatoAgenciaTelefone}
              />
            </FormControl>
          </SimpleGrid>
        )}


      <SimpleGrid columns={4} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Cliente
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Cliente"
            isRequired={true}
            name={"cliente"}
            defaultValue={{
              label: accountSelected?.cliente?.nome,
              value: accountSelected?.cliente?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Nome do Contato do Responsável do Cliente
          </FormLabel>
          <Select value={contatoCliente?.id} size="md">
            <option value={contatoCliente?.id}>{contatoCliente?.nome}</option>
          </Select>
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Email do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Email do Contato do Cliente"
            fontWeight="bold"
            size="md"
            disabled={false}
            value={accountSelected?.contatoClienteEmail}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Telefone do Contato do Cliente
          </FormLabel>

          <Input
            fontSize="sm"
            ms={{ base: "0px", md: "0px" }}
            type="text"
            placeholder=" Telefone de Contato do Cliente"
            fontWeight="bold"
            size="md"
            onChange={(e) => {}}
            value={accountSelected?.contatoClienteTelefone}
          />
        </FormControl>
      </SimpleGrid>

      <SimpleGrid columns={4} spacing={2} mt={4}>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Modelo de Negócio
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque o Modelo de Negócio"
            name={"modelo negocio"}
            value={{
              label: accountSelected?.modeloNegocio?.nome,
              value: accountSelected?.modeloNegocio?.id,
            }}
          />
        </FormControl>
        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Condição de Pagamento
          </FormLabel>

          <AutoComplete<OptionType, false, GroupBase<OptionType>>
            size="md"
            placeholder="Busque a Forma de Pagamento"
            name={"formaPagametno"}
            value={{
              label: accountSelected?.condicaoPagamento?.nome,
              value: accountSelected?.condicaoPagamento?.id,
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Validade da Proposta
          </FormLabel>
          <SingleDatepicker
            name="date-input-validade"
            configs={{
              dateFormat: "dd/MM/yyyy",
              dayNames: "DSTQQSS".split(""), // length of 7
              monthNames:
                "JANEIRO FEVEREIRO MARÇO ABRIL MAIO JUNHO JULHO AGOSTO SETEMBRO OUTUBRO NOVEMBRO DEZEMBRO".split(
                  " "
                ), // length of 12
              firstDayOfWeek: 0,
              // default is 0, the dayNames[0], which is Sunday if you don't specify your own dayNames,
            }}
            propsConfigs={{
              dayOfMonthBtnProps: {
                selectedBtnProps: {
                  background: "#422afb",
                  color: "white",
                },
              },
            }}
            date={new Date(accountSelected?.validade)}
            onDateChange={(date: any) => {
              //
            }}
          />
        </FormControl>

        <FormControl>
          <FormLabel
            display="flex"
            ms="4px"
            fontSize="sm"
            fontWeight="bold"
            color={textColor}
            mb="8px"
          >
            Periodo de Veiculação
          </FormLabel>
          <NumberInput
            precision={0}
            step={3}
            max={24}
            min={1}
            defaultValue={accountSelected?.periodoVeiculacao}
          >
            <NumberInputField />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        </FormControl>
      </SimpleGrid>
    </Box>
  );
};
export default OrderHeader;
